import { motion } from 'framer-motion';
import { PageHero, SectionHeader } from '@/components/common/Sections';
import { AwardCard, CTABanner } from '@/components/common/Cards';
import { IMAGES } from '@/lib/constants';
import { useCMS } from '@/lib/useCMS';
import { Certificate, Medal, Trophy } from '@phosphor-icons/react';

export default function AwardsPage() {
  const { awards } = useCMS();
  const certifications = [
    { title: "IATA Accredited Agent", year: "Since 2000" },
    { title: "TAAI Member", year: "Since 1995" },
    { title: "TAFI Certified", year: "Since 1998" },
    { title: "ISO 9001:2015 Certified", year: "Since 2018" },
  ];

  return (
    <div className="page-transition">
      <PageHero title="Awards & Achievements" subtitle="Recognition of our commitment to excellence in travel" backgroundImage={IMAGES.corporateTravel} />

      <section data-testid="awards-section" className="section-padding bg-white">
        <div className="container-custom">
          <SectionHeader overline="Recognition" title="Awards We're Proud Of" />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {awards.map((award, index) => (<AwardCard key={award.id || index} award={award} index={index} />))}
          </div>
        </div>
      </section>

      <section data-testid="certifications-section" className="section-padding bg-[#0A1F3D] relative grain-overlay">
        <div className="container-custom relative z-10">
          <SectionHeader overline="Accreditations" title="Certifications & Memberships" light />
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }} className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 text-center">
                <Certificate size={40} className="text-[#D4AF37] mx-auto mb-4" />
                <h3 className="font-bold text-white mb-2">{cert.title}</h3>
                <p className="text-[#D4AF37] text-sm">{cert.year}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-[#F5F5F5]">
        <div className="container-custom">
          <SectionHeader overline="Milestones" title="Key Achievements" />
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {[
              { icon: Trophy, title: "1M+ Happy Travelers", description: "Trusted by over a million customers since 1993" },
              { icon: Medal, title: "98% Visa Approval", description: "Industry-leading visa approval success rate" },
              { icon: Certificate, title: "Dual IATA Status", description: "One of few agencies with dual accreditation" },
            ].map((item, index) => (
              <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }} className="text-center bg-white p-8 card-hover">
                <item.icon size={48} className="text-[#D4AF37] mx-auto mb-4" />
                <h3 className="text-xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-2">{item.title}</h3>
                <p className="text-[#4A5568] text-sm">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
